import { ListGuesser } from 'react-admin'
import NationIcon from '@material-ui/icons/Flag';

export default {
  list: ListGuesser,

  icon: NationIcon,
}